function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from './setting-field.scss';
import template from './setting-field.html';

export var SettingFieldComponent = {
  template: template,
  styles: styles,
  bindings: {
    viewLabel: "@" },

  transclude: {
    field: "?fieldContent" },

  controller: /*#__PURE__*/function () {
    function SettingFieldComponentController() {
      "ngInject";_classCallCheck(this, SettingFieldComponentController);
      console.log(this);
      this.hasSelected = false;
    }_createClass(SettingFieldComponentController, [{ key: "$onInit", value: function $onInit()

      {
        angular.element.each(angular.element('textarea[data-autoresize]'), function () {var _this = this;
          var offset = this.offsetHeight - this.clientHeight;

          var resizeTextarea = function resizeTextarea(el) {
            angular.element(el).css('height', '100%').css('height', el.scrollHeight + offset);
            if (el.scrollHeight + offset > 62) {
              angular.element(el).parent().parent().css('height', 'auto').css('height', el.scrollHeight + offset);
            } else {
              angular.element(el).parent().parent().css('height', 55);
            }
          };
          angular.element(this).on('keyup input', function () {resizeTextarea(_this);}).removeAttr('data-autoresize');
        });
      } }, { key: "onSelectField", value: function onSelectField(

      event) {var _this2 = this;
        if (!this.hasSelected) {
          angular.element(event.currentTarget).find('*').select();
          this.hasSelected = true;
        }

        angular.element(event.currentTarget).find('*').on('blur', function () {
          _this2.hasSelected = false;
        });
      } }]);return SettingFieldComponentController;}() };